import React from "react";
import { useSelector } from "react-redux";
import KanbanBoard from "../../../components/Kanban/KanbanBoard";

const ExitStages = ({tab , onSelectCandidate}) => {
  const { currentType, pipelineByType } = useSelector(
    (state) => state.pipeline
  );

  const kanbanData =
    pipelineByType[currentType]?.kanbanData || [];

  // console.log(kanbanData,"kanbanData");
    

 const leadData = kanbanData.filter(
    (stage) => stage.type === "LEAD"
  );

  const interviewData = kanbanData.filter(
    (stage) => stage.type === "INTERVIEW"
  );

  return <KanbanBoard stages={interviewData} menu={true} activeTab={tab} onSelectCandidate={onSelectCandidate} />;
};

export default ExitStages;